import { API } from 'aws-amplify';

export async function runAssignment(): Promise<{ message: string }> {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = 'api/testing/run-assignment';

  return await API.post(apiName, path, {});
}
